import type {
  FollowUpRelationItem,
  FollowUpRelationTargetType,
} from '@/services/bff/types/follow-up';
import { FOLLOW_UP_BIZ_TYPES } from '../markdown/content';

export const RELATION_FIELDS = {
  lead: 'leadUuids',
  customer: 'customerUuids',
  contact: 'contactUuids',
  opportunity: 'opportunityUuids',
} as const;
export const RELATION_LABELS: Record<FollowUpRelationTargetType, string> = {
  lead: '线索',
  customer: '客户',
  contact: '联系人',
  opportunity: '商机',
  contract: '合同',
  quote: '报价',
  receipt: '收款',
};
export type RelationSelection = Partial<
  Record<(typeof RELATION_FIELDS)[keyof typeof RELATION_FIELDS], string[]>
> & {
  extraRelations?: FollowUpRelationItem[];
};
export function primaryType(bizType?: number) {
  return Object.keys(FOLLOW_UP_BIZ_TYPES).find(
    (type) => FOLLOW_UP_BIZ_TYPES[type] === Number(bizType),
  ) as FollowUpRelationTargetType | undefined;
}
export function relationSelection(
  relations: FollowUpRelationItem[],
): RelationSelection {
  const result: RelationSelection = {
    extraRelations: relations.filter(
      (item) => !(item.targetType in RELATION_FIELDS),
    ),
  };
  for (const [type, field] of Object.entries(RELATION_FIELDS))
    result[field] = [
      ...new Set(
        relations
          .filter((item) => item.targetType === type)
          .map((item) => item.targetUuid),
      ),
    ];
  return result;
}
export function selectedRelations(
  values: RelationSelection,
  previous?: { bizType?: number; bizUuid?: string },
) {
  const map = new Map<string, FollowUpRelationItem>();
  const input = [...(values.extraRelations || [])];
  for (const [type, field] of Object.entries(RELATION_FIELDS))
    for (const uuid of values[field] || [])
      input.push({
        targetType: type as FollowUpRelationTargetType,
        targetUuid: uuid,
      });
  for (const item of input)
    if (item.targetUuid)
      map.set(`${item.targetType}:${item.targetUuid}`, {
        ...item,
        relationRole: 'related',
      });
  const relations = [...map.values()].sort(
    (a, b) =>
      FOLLOW_UP_BIZ_TYPES[a.targetType] - FOLLOW_UP_BIZ_TYPES[b.targetType],
  );
  const primary =
    relations.find(
      (item) =>
        item.targetType === primaryType(previous?.bizType) &&
        item.targetUuid === previous?.bizUuid,
    ) || relations[0];
  if (primary) primary.relationRole = 'primary';
  return {
    relations,
    bizType: primary ? FOLLOW_UP_BIZ_TYPES[primary.targetType] : undefined,
    bizUuid: primary?.targetUuid,
  };
}
